import Key from 'assets/icons/key.svg'
import KeyInverted from 'assets/icons/key-white.svg'
import RetouchedEveningPhoto from 'assets/icons/retouched-evening-photo.svg'
import RetouchedEveningPhotoInverted from 'assets/icons/retouched-evening-photo-white.svg'
import DigitalRetouching from 'assets/icons/digital-retouching.svg'
import DigitalRetouchingInverted from 'assets/icons/digital-retouching-white.svg'
import Walkthrough from 'assets/icons/walkthrough.svg'
import WalkthroughInverted from 'assets/icons/walkthrough-white.svg'
import ProductPremiumPhoto from 'assets/icons/product-premium-photo.svg'

const EXCLUDE_STATES = ['delivered', 'cancelled', 'booked']

const KEY_PICKUP = {
  type: 'key-pickup',
  icon: Key,
  iconInverted: KeyInverted,
  text: 'Husk at du har nøkkelhenting i dag',
}
const RETOUCHED_EVENING_PHOTOS = {
  type: 'retouched-evening-photos',
  icon: RetouchedEveningPhoto,
  iconInverted: RetouchedEveningPhotoInverted,
  text: 'Husk å ta fasadebilder for redigerte kveldsfoto',
}
const DIGITAL_RETOUCHED_RENOVATION = {
  type: 'digital-retouched-renovation',
  icon: DigitalRetouching,
  iconInverted: DigitalRetouchingInverted,
  text: 'Husk å ta egnede bilder for digital møblering',
}
const DIGITAL_RETOUCHED_FURNISHING = {
  type: 'digital-retouched-furnishing',
  icon: DigitalRetouching,
  iconInverted: DigitalRetouchingInverted,
  text: 'Husk å ta egnede bilder for digital oppussing',
}
const DIGITAL_RETOUCHED_PEOPLE = {
  type: 'digital-retouched-people',
  icon: DigitalRetouching,
  iconInverted: DigitalRetouchingInverted,
  text: 'Husk å ta egnede bilder for Mennesker i bildene',
}
const WALKTHROUGH = {
  type: 'walkthrough',
  icon: Walkthrough,
  iconInverted: WalkthroughInverted,
  text: 'Husk å levere 360º visning',
}
const PREMIUM_SERVICE = {
  type: 'premium-service',
  icon: ProductPremiumPhoto,
  iconInverted: ProductPremiumPhoto,
  text: 'Dette oppdraget er Premium service',
}

export default function getBookingReminders(booking) {
  const reminders = []
  const estateProducts = booking.estate.products.edges.map(({ node }) => node)
  const bookingProducts = booking.products.edges.map(({ node }) => node)

  const estateHasWaitingProductType = (type) =>
    estateProducts.some(
      (p) => p.__typename === type && !EXCLUDE_STATES.includes(p.state)
    )

  const bookingHasWaitingConsumerType = (type) =>
    bookingProducts.some(
      (p) =>
        p.usedAsInputFor &&
        p.usedAsInputFor.some(
          (u) => u.__typename === type && !EXCLUDE_STATES.includes(u.state)
        )
    )

  if (!!booking.premiumService) reminders.push(PREMIUM_SERVICE)
  if (!!booking.pickUpKeysInstructions) reminders.push(KEY_PICKUP)
  if (estateHasWaitingProductType('RetouchedEveningPhotoProduct'))
    reminders.push(RETOUCHED_EVENING_PHOTOS)
  if (estateHasWaitingProductType('DigitalRetouchedRenovationPhotoProduct'))
    reminders.push(DIGITAL_RETOUCHED_RENOVATION)
  if (estateHasWaitingProductType('DigitalRetouchedFurnishingPhotoProduct'))
    reminders.push(DIGITAL_RETOUCHED_FURNISHING)
  if (estateHasWaitingProductType('DigitalRetouchedPeoplePhotoProduct'))
    reminders.push(DIGITAL_RETOUCHED_PEOPLE)
  if (bookingHasWaitingConsumerType('WalkthroughProduct'))
    reminders.push(WALKTHROUGH)

  return reminders
}
